import { makeRetriableGetRequest } from '../api/apiActions';

class RANServiceClient {
    static URL = '/lanternran/v01';

    static NAME = 'ran';

    static MEASURE = 'RAN';

    static MEASURES = {
        'RAN-NUMBERS': 'RAN-NUMBERS',
    };

    /**
     * Construct and return the API URL to get forms
     */
    static constructFormEndpoint(measureType) {
        let endpoint = `${RANServiceClient.URL}/forms`;

        if (measureType) {
            endpoint = `${endpoint}?measure_type=${measureType}`;
        }

        return endpoint;
    }

    /**
     * Construct and return the API endpoint to post results
     */
    static constructPostResultEndpoint() {
        return `${RANServiceClient.URL}/results`;
    }

    /**
     * Construct and return the URL API endpoint for a list of results
     */
    static constructResultListEndpoint({
        studentId, grade, period, schoolYear,
    } = {}) {
        let endpoint = `${RANServiceClient.URL}/results`;
        const params = [];

        if (studentId) {
            params.push(`student_uids=${studentId}`);
        }
        if (grade) {
            params.push(`grade=${grade}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (schoolYear) {
            params.push(`school_year=${schoolYear}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }

        return endpoint;
    }

    /**
     * Sends GET request to RAN API to get forms content
     */
    static getForm = (measureType, retryActionName) => (dispatch) => {
        const endpoint = RANServiceClient.constructFormEndpoint(measureType);
        return dispatch(makeRetriableGetRequest(endpoint, retryActionName));
    };
}

export default RANServiceClient;
